import React, { useState, useEffect, useRef } from "react";

import { useParams, Link } from "react-router-dom";
import moment from "moment";
import LinesEllipsis from "react-lines-ellipsis";

import Header from "../../../layout/header";
import Footer from "../../../layout/footer";

import banner from "../../../assets/img/banner-information.jpg";
import imgContent from "../../../assets/img/content-web.jpg";
import web01 from "../../../assets/img/webi-01.jpg";
import web02 from "../../../assets/img/webi-02.jpg";
import web03 from "../../../assets/img/webi-03.jpg";
import Loading from "../../../components/loading";
import { getData } from "../../../services/getService";
import { axiosJson, base_api } from "../../../configs/fetcher";

const eventColorThemes = [
  { text: "#24458c", button: "#24458c", register: "#1f3d7b" },
  { text: "#1769aa", button: "#1769aa", register: "#1365a5" },
  { text: "#00857c", button: "#00857c", register: "#007c74" },
  { text: "#5a913f", button: "#5a913f", register: "#548e3c" },
];

const eventApi =
  window.location.hostname === "localhost"
    ? "http://localhost/seameo-seps/service/api/v1"
    : base_api;

const Main = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataOne, setDataOne] = useState({});
  const [dataTwo, setDataTwo] = useState({});
  const [dataThree, setDataThree] = useState([]);
  const [dataNews, setDataNews] = useState([]);
  const [eventSessions, setEventSessions] = useState([]);
  const [isDetailExpanded, setIsDetailExpanded] = useState(false);
  const [sessionDetail, setSessionDetail] = useState(null);
  const [detailTab, setDetailTab] = useState("speakers");
  const [expandedBiographyId, setExpandedBiographyId] = useState(null);
  const [posterPopup, setPosterPopup] = useState(null);
  const [isPosterPopupOpen, setIsPosterPopupOpen] = useState(false);

  const called = useRef(true);
  const posterHoverTimer = useRef(null);

  useEffect(() => {
    if (called.current) {
      Promise.all([
        fetchDataOne(),
        fetchDataTwo(),
        fetchDataThree(),
        fetchEventSessions(),
      ]).then((res) => {
        setIsLoading(false);
      });
    }
    return () => {
      called.current = false;
    };
  }, []);

  const fetchDataOne = async () => {
    getData("pageawards", "virtual")
      .then((response) => {
        if (response.status === "success") {
          setDataOne(response.data);
        }
      })
      .catch((e) => {
        console.log(e.response.data.error);
      });
  };
  const fetchDataTwo = async () => {
    getData("pageawards", "upcoming")
      .then((response) => {
        if (response.status === "success") {
          setDataTwo(response.data);
        }
      })
      .catch((e) => {
        console.log(e.response.data.error);
      });
  };
  const fetchDataThree = async () => {
    getData("pageawards", "previous")
      .then((response) => {
        if (response.status === "success") {
          setDataThree(response.data);
        }
      })
      .catch((e) => {
        console.log(e.response.data.error);
      });
  };

  const fetchEventSessions = async () => {
    try {
      const response = await axiosJson.get(`${eventApi}/events`);
      setEventSessions(response.data?.events || []);
    } catch (error) {
      console.error("Unable to load event sessions.", error);
    }
  };

  const showPosterPopup = (session) => {
    window.clearTimeout(posterHoverTimer.current);
    posterHoverTimer.current = window.setTimeout(() => {
      setPosterPopup(session);
      window.requestAnimationFrame(() =>
        window.requestAnimationFrame(() => setIsPosterPopupOpen(true))
      );
    }, 180);
  };

  const cancelPosterPopup = () => {
    window.clearTimeout(posterHoverTimer.current);
  };

  const closePosterPopup = () => {
    setIsPosterPopupOpen(false);
    window.setTimeout(() => setPosterPopup(null), 420);
  };

  const showSessionDetails = async (slug) => {
    try {
      const response = await axiosJson.get(`${eventApi}/events/${slug}`);
      setSessionDetail(response.data);
      setDetailTab("speakers");
      setExpandedBiographyId(null);
      window.setTimeout(
        () =>
          document
            .getElementById("session-details")
            ?.scrollIntoView({ behavior: "smooth", block: "start" }),
        0
      );
    } catch (error) {
      console.error("Unable to load session details.", error);
    }
  };
  return (
    <>
      <div id="outer-container" style={{}}>
        <Header page="activities" sub="information" />
        <div className="wrapper bg-white box-index">
          {isLoading ? <Loading /> : null}
          <section className="pb-md-5 bg-top">
            <div className="container-fluid">
              <div className="row justify-content-center pb-md-5 text-start">
                <div className="col-12 col-md-12 col-lg-12 p-0">
                  <div className="">
                    <img
                      src={
                        process.env.REACT_APP_IMG_LINK +
                        "/uploads/awards/" +
                        dataOne.id +
                        "/" +
                        dataOne.img
                      }
                      className="w-100 rounded"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-9 mt-3 mt-md-4">
                  {/* <div className="font-60 weight-700">{dataOne.topic}</div> */}
                  <div className="mb-5 pt-3">
                    <div
                      className={`font-18 text-justify content-custom ${
                        isDetailExpanded ? "" : "virtual-detail-collapsed"
                      }`}
                      dangerouslySetInnerHTML={{ __html: dataOne.detail }}
                    />
                    {dataOne.detail && (
                      <button
                        type="button"
                        className="btn btn-register mt-3 px-3"
                        style={{
                          borderRadius: "20px",
                          background: "#c98b00",
                          color: "#fff",
                          borderColor: "#c98b00",
                        }}
                        onClick={() =>
                          setIsDetailExpanded((expanded) => !expanded)
                        }
                      >
                        {isDetailExpanded ? "Read Less" : "Read More"}
                      </button>
                    )}
                  </div>

                  {/* <div className="row justify-content-center py-5 mb-md-5 text-start">
                                        <div className="col-12 col-md-8 col-lg-6">
                                            <div className="position-relative px-4 py-3 mt-3 mt-md-5 btn-delay">
                                                <div
                                                    className="news-topic text-white px-2 res-font-14"
                                                    style={{ lineHeight: "1.3" }}
                                                >
                                                    SEP-SDGs in Action: <br /> Virtual Learning Series
                                                </div>
                                                <a
                                                    href="/activities/webinarsDetail"
                                                    className="go-see position-absolute absolute-center-right weight-700 font-20"
                                                >
                                                    See Details
                                                </a>
                                            </div>
                                        </div>
                                    </div> */}
                  {dataTwo && (
                    <>
                      <div className="font-60 weight-700 mt-3">
                        Upcoming Webinars
                      </div>
                      <div
                        className="box-archives mt-5"
                        style={{
                          background: "#F5F5F5",
                          boxShadow: "0px 20px 30px 0px rgba(0, 0, 0, 0.10)",
                        }}
                      >
                        <div className="row">
                          <div className="col-12 col-md-4 col-lg-4">
                            <div className="p-4">
                              <img
                                src={
                                  process.env.REACT_APP_IMG_LINK +
                                  "/uploads/awards/" +
                                  dataTwo.id +
                                  "/" +
                                  dataTwo.img
                                }
                                className="w-100 rounded"
                                alt=""
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-8 col-lg-8">
                            <div className="pb-5 pb-md-0 pt-3 pt-md-3 px-4 px-md-5">
                              <div className="sub-topic">{dataTwo.topic}</div>
                              <div className="font-14">{dataTwo.subtopic}</div>
                              <div className="mt-3">
                                <div
                                  className="text-justify"
                                  dangerouslySetInnerHTML={{
                                    __html: dataTwo.detail,
                                  }}
                                />
                              </div>
                              <div className="mt-5">
                                <a
                                  href={dataTwo.detailSub}
                                  target="_blank"
                                  className="btn btn-register"
                                >
                                  Registration
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* <div className="topic mb-3 mt-5 pt-5">Event Sessions</div> */}
                  <div className="row" id="event-sessions">
                    {eventSessions.length ? (
                      eventSessions.map((session, index) => {
                        const colorTheme =
                          eventColorThemes[index % eventColorThemes.length];

                        return (
                          <div
                            className="col-12 col-md-6 col-lg-3 mb-4"
                            key={session.slug}
                          >
                            <div className="h-100">
                              {session.cover_image ? (
                                <Link
                                  to={`/event-register/${session.slug}`}
                                  className="event-poster-thumb"
                                  aria-label={`Register for ${session.title}`}
                                  onMouseEnter={() => showPosterPopup(session)}
                                  onMouseLeave={cancelPosterPopup}
                                >
                                  <img
                                    src={session.cover_image}
                                    className="w-100 rounded"
                                    alt={session.title}
                                  />
                                </Link>
                              ) : (
                                <Link
                                  to={`/event-register/${session.slug}`}
                                  className="rounded d-flex align-items-center justify-content-center text-decoration-none text-dark"
                                  style={{
                                    height: "145px",
                                    background: "#ddd",
                                  }}
                                >
                                  SEAMEO SEPS
                                </Link>
                              )}
                              <div
                                className="news-topic mt-3"
                                style={{
                                  color: colorTheme.text,
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 2,
                                  overflow: "hidden",
                                  minHeight: "3.2em",
                                }}
                              >
                                {session.title}
                              </div>
                              <div
                                className="font-14 mt-2"
                                style={{ color: colorTheme.text }}
                              >
                                {session.event_start ? (
                                  <>
                                    <div>
                                      {moment(session.event_start).format(
                                        "dddd, D MMM YYYY"
                                      )}
                                    </div>
                                    <div>
                                      {moment(session.event_start).format(
                                        "HH:mm"
                                      )}
                                      {session.event_end
                                        ? `-${moment(session.event_end).format(
                                            "HH:mm"
                                          )}`
                                        : ""}{" "}
                                      BKK (GMT+7)
                                    </div>
                                  </>
                                ) : (
                                  "Date to be confirmed"
                                )}
                              </div>
                              <div className="d-flex gap-2 mt-3">
                                <button
                                  type="button"
                                  className="btn text-white font-14 px-3"
                                  style={{
                                    background: colorTheme.button,
                                    borderColor: colorTheme.button,
                                    borderRadius: "20px",
                                  }}
                                  onClick={() =>
                                    showSessionDetails(session.slug)
                                  }
                                >
                                  More Details
                                </button>
                                {session.registration_opened ? (
                                  <Link
                                    to={`/event-register/${session.slug}`}
                                    className="btn text-white font-14 px-3"
                                    style={{
                                      background: colorTheme.register,
                                      borderColor: colorTheme.register,
                                      borderRadius: "20px",
                                    }}
                                  >
                                    Register
                                  </Link>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn font-14 px-3"
                                    disabled
                                    title="Registration is not open yet"
                                    style={{
                                      background: "#b9b9b9",
                                      borderColor: "#b9b9b9",
                                      borderRadius: "20px",
                                      color: "#fff",
                                      cursor: "not-allowed",
                                      opacity: 1,
                                    }}
                                  >
                                    Register
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-12 text-muted">-- No sessions --</div>
                    )}
                  </div>

                  {posterPopup && (
                    <div
                      className={`event-poster-popup ${
                        isPosterPopupOpen ? "is-open" : ""
                      }`}
                      role="dialog"
                      aria-modal="true"
                      aria-label={`${posterPopup.title} poster`}
                    >
                      <div className="event-poster-popup-card">
                        <button
                          type="button"
                          className="event-poster-popup-close"
                          aria-label="Close poster"
                          onClick={closePosterPopup}
                          autoFocus
                        >
                          ×
                        </button>
                        <Link
                          to={`/event-register/${posterPopup.slug}`}
                          className="event-poster-popup-link"
                          aria-label={`Register for ${posterPopup.title}`}
                        >
                          <img
                            src={posterPopup.cover_image}
                            alt={posterPopup.title}
                          />
                        </Link>
                      </div>
                    </div>
                  )}

                  {sessionDetail && (
                    <section
                      id="session-details"
                      className="mt-4 mb-5"
                      style={{
                        background: "#fff",
                        border: "1px solid #e2e2e2",
                        borderRadius: "12px",
                        overflow: "hidden",
                        boxShadow: "0 4px 14px rgba(0,0,0,.18)",
                      }}
                    >
                      <div
                        className="d-flex border-bottom"
                        style={{ background: "#f7f7f7", padding: "0" }}
                      >
                        <button
                          type="button"
                          className={`btn border-0 ${
                            detailTab === "speakers"
                              ? "text-white"
                              : "text-muted"
                          }`}
                          style={{
                            background:
                              detailTab === "speakers"
                                ? "#4b9968"
                                : "transparent",
                            borderRadius: "10px 10px 0 0",
                            padding: "8px 16px",
                          }}
                          onClick={() => setDetailTab("speakers")}
                        >
                          Speaker
                        </button>
                        <button
                          type="button"
                          className={`btn border-0 ${
                            detailTab === "materials"
                              ? "text-white"
                              : "text-muted"
                          }`}
                          style={{
                            background:
                              detailTab === "materials"
                                ? "#4b9968"
                                : "transparent",
                            borderRadius: "10px 10px 0 0",
                            padding: "8px 16px",
                          }}
                          onClick={() => setDetailTab("materials")}
                        >
                          Materials
                        </button>
                      </div>
                      {detailTab === "speakers" ? (
                        <div className="px-4" style={{ lineHeight: "2" }}>
                          {(sessionDetail.speakers || []).length ? (
                            sessionDetail.speakers.map((speaker, index) => (
                              <article
                                className="row py-4 border-bottom"
                                key={speaker.id}
                              >
                                <div className="col-12 col-md-3 text-center mb-3 mb-md-0">
                                  {speaker.photo && (
                                    <img
                                      src={speaker.photo}
                                      alt={speaker.name}
                                      className="rounded-circle"
                                      style={{
                                        width: "120px",
                                        height: "120px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  )}
                                  <div className="font-14 weight-700 mt-2">
                                    {speaker.name}
                                  </div>
                                  <div className="font-12">
                                    {speaker.job_title}
                                  </div>
                                  <div className="font-12">
                                    {speaker.organization}
                                  </div>
                                </div>
                                <div className="col-12 col-md-9">
                                  {speaker.description && (
                                      <div
                                        className="mb-3"
                                        style={{ lineHeight: "1.4" }}
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            speaker.description,
                                        }}
                                      />
                                    )}
                                  <div
                                    className="mt-2"
                                    style={{
                                      background: "#fff",
                                      border: "1px solid #e7e0d0",
                                      borderRadius: "7px",
                                      boxShadow: "0 2px 6px rgba(0,0,0,.18)",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="btn d-flex align-items-center justify-content-between w-100 font-14 weight-700 text-decoration-none"
                                      style={{
                                        color: "#c98b00",
                                        background: "transparent",
                                        border: 0,
                                        borderRadius: 0,
                                        padding: "8px 12px",
                                        textAlign: "left",
                                      }}
                                      onClick={() =>
                                        setExpandedBiographyId((current) =>
                                          current === speaker.id
                                            ? null
                                            : speaker.id
                                        )
                                      }
                                    >
                                      <span>Biography</span>
                                      <span aria-hidden="true">
                                        {expandedBiographyId === speaker.id
                                          ? "⌃"
                                          : "⌄"}
                                      </span>
                                    </button>
                                    {expandedBiographyId === speaker.id && (
                                      <div
                                        className="border-top"
                                        style={{
                                          padding: "18px 20px",
                                          boxSizing: "border-box",
                                          overflowWrap: "anywhere",
                                          wordBreak: "break-word",
                                          lineHeight: "1.4",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: speaker.biography || "",
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </article>
                            ))
                          ) : (
                            <div className="text-muted p-5 text-center">
                              Speaker information will be available soon.
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="px-4">
                          {(sessionDetail.materials || []).length ? (
                            sessionDetail.materials.map((material) => (
                              <a
                                className="d-block py-2"
                                key={material.id}
                                href={material.download_url}
                              >
                                {material.title || material.file_name}
                              </a>
                            ))
                          ) : (
                            <div className="text-muted p-5 text-center">
                              coming soon
                            </div>
                          )}
                        </div>
                      )}
                    </section>
                  )}

                  {/* <div className="topic mb-4 mt-5 pt-5">Previous Webinars</div>
                                    <div>
                                        <div className="row ">
                                            {dataThree.length ? dataThree.sort((a, b) => parseInt(b.id) - parseInt(a.id)).map((val, index) => (
                                                <div className="col-12 col-md-4 col-lg-4 mb-5" key={index}>
                                                    <span

                                                        className="box-web-col rounded-30 pb-3 overflow-hidden cursor-pointer"
                                                    >
                                                        <div>
                                                            <img src={process.env.REACT_APP_IMG_LINK + "/uploads/awards/" + val.id + '/' + val.img} className="w-100" alt="" />
                                                        </div>
                                                        <div className="news-topic p-3">
                                                            {val.topic}
                                                        </div>
                                                        <div className="pb-4 px-3 mt-4 text-center">
                                                            <div className="row ">
                                                                {val.subtopic &&
                                                                    <div className="col-6 col-md-6 pe-1">
                                                                        <a className="btn btn-about text-white font-16 w-100 px-0" href={val.subtopic} target="_blank" style={{ paddingTop: '12px', paddingBottom: '12px' }}>Details</a>
                                                                    </div>
                                                                }
                                                                <div className="col-6 col-md-6 ps-1">
                                                                    <a className="btn btn-blue font-16 w-100 px-0" href={val.detailSub} target="_blank" style={{ paddingTop: '12px', paddingBottom: '12px' }}>Watch</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </div>
                        );
                      }) : <div className="col-12 col-md-12 col-lg-12 mb-5">-- No data --</div>}

                                        </div>
                                    </div> */}
                  {/* {dataOne.news && dataOne.news.length ?
                                        <div>
                                            <div className="topic mb-4 mt-5">News</div>
                                            <div className="row">
                                                
                                                {dataOne.news.sort((a, b) => new Date(b.dateActive) - new Date(a.dateActive)).map((val, index) => (
                                                    <div
                                                        className="col-12 col-md-12 col-lg-4"
                                                        key={index}
                                                    >
                                                        <Link
                                                            to={"/newsandgallery/news/" + val.newsId}
                                                            className="a-news pb-4 mb-4 mb-md-5"
                                                        >
                                                            <div className="row text-start">
                                                                <div className="col-12 col-md-12 col-lg-12">
                                                                    <div>
                                                                        <img
                                                                            src={
                                                                                process.env.REACT_APP_IMG_LINK +
                                                                                "/uploads/news/" +
                                                                                val.newsId +
                                                                                "/" +
                                                                                val.banner
                                                                            }
                                                                            className="w-100 rounded"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-12 col-lg-12">
                                                                    <div className="font-14 mt-2">
                                                                        {moment(val.dateActive).format("D MMMM Y")}
                                                                    </div>

                                                                    <div className="news-topic mt-3 mt-md-0"
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: val.topic,
                                                                        }}
                                                                    />
                                                                 
                                                                    <div className="mt-4">
                                                                        <LinesEllipsis
                                                                            text={val.subTopic}
                                                                            maxLine="3"
                                                                            ellipsis="..."
                                                                            trimRight
                                                                            basedOn="letters"
                                                                        />
                                                                    </div>
                                                                    <div className="mt-3">
                                                                        <a style={{ color: "#e6c12f" }}>
                                                                            Read More
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                        );
                      })}
                                            </div>
                                        </div>
                                        : null} */}
                </div>
              </div>
            </div>
          </section>

          <style>{`.virtual-detail-collapsed{max-height:620px;overflow:hidden;position:relative}.virtual-detail-collapsed:after{content:"";position:absolute;left:0;right:0;bottom:0;height:42px;background:linear-gradient(transparent,#fff)}.event-poster-thumb{display:block;cursor:pointer}.event-poster-popup{position:fixed;inset:0;z-index:1050;display:flex;align-items:center;justify-content:center;padding:30px;background:rgba(0,0,0,.72);opacity:0;backdrop-filter:blur(0);transition:opacity .42s ease,backdrop-filter .42s ease}.event-poster-popup.is-open{opacity:1;backdrop-filter:blur(3px)}.event-poster-popup-card{position:relative;max-width:min(90vw,780px);max-height:88vh;opacity:0;transform:translateY(26px) scale(.9);transform-origin:center;will-change:transform,opacity;transition:opacity .46s ease,transform .52s cubic-bezier(.16,1,.3,1)}.event-poster-popup.is-open .event-poster-popup-card{opacity:1;transform:translateY(0) scale(1)}.event-poster-popup-close{position:absolute;top:-14px;right:-14px;z-index:2;width:38px;height:38px;border:2px solid #fff;border-radius:50%;background:#222;color:#fff;font-size:26px;line-height:30px;cursor:pointer}.event-poster-popup-link{display:block;max-width:100%;max-height:88vh}.event-poster-popup-link img{display:block;max-width:100%;max-height:88vh;border-radius:10px;box-shadow:0 16px 45px rgba(0,0,0,.4);object-fit:contain}@media(prefers-reduced-motion:reduce){.event-poster-popup,.event-poster-popup-card{transition:none}}`}</style>
          <Footer page="activities" sub="information" />
        </div>
      </div>
    </>
  );
};

export default Main;
